/* BENUTE — visual quick shop, with deliberate size selection. */
(() => {
  'use strict';
  const studio = window.BenuteStudio;
  if (!studio || window.BenuteQuick) return;
  window.BenuteQuick = true;
  const { open, element: el, money, safeURL, request } = studio;
  const dialog = document.getElementById('BN-Quick');
  if (!dialog) return;
  const content = dialog.querySelector('[data-bn-quick-content]');
  const status = dialog.querySelector('[data-bn-quick-status]');
  const normalize = value => String(value || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  let sequence = 0, controller;
  dialog.addEventListener('close', () => { sequence++; controller?.abort(); });
  async function show(button) {
    const productURL = safeURL(button.dataset.bnQuickUrl);
    if (!open(dialog, button)) { location.assign(productURL); return; }
    controller?.abort(); controller = new AbortController();
    const current = ++sequence;
    content.replaceChildren(); dialog.classList.add('is-loading'); dialog.setAttribute('aria-busy', 'true');
    status.textContent = 'Preparando sua escolha…';
    try {
      const url = new URL(productURL); url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const product = await request(url, { signal: controller.signal });
      if (current !== sequence || !dialog.open) return;
      if (!Array.isArray(product.variants) || !product.variants.length || product.variants.length >= 250 || product.requires_selling_plan) throw new Error('Confira todas as opções na página da peça.');
      dialog.classList.remove('is-loading'); dialog.setAttribute('aria-busy', 'false'); status.textContent = '';
      const variants = product.variants;
      const options = (product.options || []).map((option, index) => ({ name: typeof option === 'string' ? option : option.name, values: [...new Set(variants.map(variant => variant.options[index]))] }));
      const isDefault = variants.length === 1 && variants[0].title === 'Default Title';
      const colorIndex = options.findIndex(option => ['cor', 'color', 'colour'].includes(normalize(option.name)));
      const sizeIndex = options.findIndex(option => ['tamanho', 'size', 'tamanhos', 'numeracao'].includes(normalize(option.name)));
      const initial = variants.find(variant => String(variant.id) === new URL(productURL).searchParams.get('variant')) || variants.find(variant => variant.available) || variants[0];
      const chosen = options.map((option, index) => index === colorIndex || option.values.length === 1 || isDefault ? initial.options[index] : null);
      const media = el('div', 'bn-quick-media');
      const image = el('img', 'bn-quick-image'); image.width = 640; image.height = 850; image.alt = product.title;
      const controls = el('div', 'bn-quick-gallery-nav');
      const previous = el('button', '', '←'); previous.type = 'button'; previous.setAttribute('aria-label', 'Foto anterior');
      const counter = el('span'); counter.setAttribute('aria-live', 'polite');
      const next = el('button', '', '→'); next.type = 'button'; next.setAttribute('aria-label', 'Próxima foto');
      controls.append(previous, counter, next); media.append(image, controls);
      const info = el('div', 'bn-quick-info');
      const title = el('h3', '', product.title);
      const price = el('p', 'bn-quick-price'); price.setAttribute('aria-live', 'polite');
      const form = el('form', 'bn-quick-form'); form.action = studio.base + 'cart/add'; form.method = 'post';
      const hidden = el('input'); hidden.type = 'hidden'; hidden.name = 'id';
      const quantity = el('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
      form.append(hidden, quantity);
      const groups = [];
      if (!isDefault) options.forEach((option, index) => {
        const group = el('fieldset', 'bn-quick-option'); group.dataset.bnQuickOption = index;
        group.classList.toggle('bn-quick-option--size', index === sizeIndex);
        const legend = el('legend'); legend.append(el('span', '', option.name));
        const selectedLabel = el('span', 'bn-quick-selected'); legend.append(selectedLabel); group.append(legend);
        const values = el('div', index === colorIndex ? 'bn-quick-colors' : 'bn-quick-sizes');
        option.values.forEach(value => {
          const choice = el('button', index === colorIndex ? 'bn-quick-color' : 'bn-quick-size'); choice.type = 'button'; choice.dataset.value = value;
          choice.setAttribute('aria-pressed', 'false');
          if (index === colorIndex) {
            const variant = variants.find(v => v.options[index] === value && v.featured_image);
            if (variant?.featured_image) { const thumb = el('img'); thumb.src = safeURL(variant.featured_image.src || variant.featured_image.url, ''); thumb.width = 48; thumb.height = 62; thumb.alt = ''; choice.append(thumb); }
          }
          choice.append(el('span', '', value));
          choice.addEventListener('click', () => {
            chosen[index] = value;
            if (index === colorIndex) {
              // Keep a size only when it remains available in the new color.
              options.forEach((_, other) => { if (other !== index && chosen[other] && !variants.some(v => v.available && v.options[index] === value && v.options[other] === chosen[other])) chosen[other] = null; });
            }
            status.textContent = ''; sync();
          });
          values.append(choice);
        });
        group.append(values); form.append(group); groups.push({ group, index, selectedLabel });
      });
      const helper = el('p', 'bn-quick-helper'); helper.setAttribute('aria-live', 'polite');
      const submit = el('button', 'bn-button bn-button--dark bn-button--full'); submit.type = 'submit'; submit.dataset.bnQuickAdd = '';
      form.append(helper, submit);
      const link = el('a', 'bn-quick-details', 'Ver todas as fotos e medidas ↗'); link.href = productURL;
      info.append(el('p', 'bn-eyebrow', product.type || 'BENUTE / MASCULINO'), title, price, form, link);
      content.append(media, info);
      let gallery = [], galleryKey = '', imageIndex = 0, submitting = false;
      function showImage() {
        const entry = gallery[imageIndex]; image.hidden = !entry;
        if (entry) { image.src = safeURL(entry.src, ''); image.alt = entry.alt || product.title; }
        controls.hidden = gallery.length < 2; counter.textContent = `${imageIndex + 1} / ${gallery.length}`;
        previous.disabled = imageIndex <= 0; next.disabled = imageIndex >= gallery.length - 1;
      }
      previous.addEventListener('click', () => { if (imageIndex > 0) { imageIndex--; showImage(); } });
      next.addEventListener('click', () => { if (imageIndex < gallery.length - 1) { imageIndex++; showImage(); } });
      function syncGallery(variant) {
        const all = (product.media || []).filter(m => m.media_type === 'image').map(m => ({ src: m.preview_image?.src || m.src, alt: String(m.alt || '').split('[cor:')[0].trim(), colors: (String(m.alt || '').match(/\[cor:([^\]]+)\]/)?.[1] || '').split('|').map(normalize).filter(Boolean) })).filter(m => m.src);
        if (!all.length) (product.images || []).forEach(src => all.push({ src, alt: product.title, colors: [] }));
        const color = normalize(chosen[colorIndex]);
        let filtered = all;
        if (colorIndex >= 0 && all.some(m => m.colors.length)) {
          const hasGroup = all.some(m => m.colors.includes(color));
          filtered = all.filter(m => m.colors.includes('todas') || (hasGroup ? m.colors.includes(color) : !m.colors.length));
        }
        const featured = variant?.featured_image?.src || variant?.featured_image?.url;
        if (!filtered.length && featured) filtered = [{ src: featured, alt: product.title }];
        if (!filtered.length && !all.length && product.featured_image) filtered = [{ src: product.featured_image, alt: product.title }];
        const key = JSON.stringify([chosen[colorIndex], filtered.map(m => m.src)]);
        if (key !== galleryKey) { galleryKey = key; gallery = filtered; imageIndex = 0; showImage(); }
      }
      function sync() {
        const matches = variant => chosen.every((value, index) => !value || variant.options[index] === value);
        const compatible = variants.filter(matches);
        const variant = chosen.every(Boolean) ? variants.find(matches) : null;
        const display = variant || compatible.find(v => v.available) || compatible[0] || initial;
        const available = compatible.filter(v => v.available);
        const minPrice = available.length ? Math.min(...available.map(v => v.price)) : display.price;
        price.replaceChildren(el('span', '', `${!variant && available.some(v => v.price !== minPrice) ? 'A partir de ' : ''}${money(variant ? variant.price : minPrice)}`));
        if (variant?.compare_at_price > variant?.price) price.append(el('s', '', money(variant.compare_at_price)));
        groups.forEach(({ group, index, selectedLabel }) => {
          selectedLabel.textContent = chosen[index] || 'Selecione';
          [...group.querySelectorAll('button')].forEach(choice => {
            const value = choice.dataset.value;
            const exists = variants.some(v => v.available && v.options[index] === value && (index === colorIndex || chosen.every((selected, other) => other === index || !selected || v.options[other] === selected)));
            choice.disabled = submitting || !exists; choice.classList.toggle('is-unavailable', !exists);
            choice.setAttribute('aria-pressed', String(chosen[index] === value));
            choice.setAttribute('aria-label', `${options[index].name}: ${value}${exists ? '' : ', indisponível'}`);
          });
        });
        hidden.value = variant?.id || '';
        const missing = options.filter((_, index) => !chosen[index]).map(option => option.name.toLowerCase());
        helper.textContent = missing.length ? `Escolha ${missing.join(' e ')} para continuar.` : variant?.available ? 'Confira sua seleção antes de adicionar.' : 'Esta combinação está indisponível.';
        submit.disabled = submitting || !variant?.available;
        submit.textContent = submitting ? 'Adicionando…' : !variant ? sizeIndex >= 0 && !chosen[sizeIndex] ? 'Escolha seu tamanho' : 'Escolha suas opções' : !variant.available ? 'Indisponível nesta opção' : button.dataset.bnQuickPreorder === 'true' ? 'Adicionar pré-venda' : 'Adicionar à sacola';
        link.href = variant ? `${productURL.split('?')[0]}?variant=${variant.id}` : productURL;
        syncGallery(display);
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting || !hidden.value || submit.disabled) return;
        submitting = true; sync(); status.textContent = '';
        try { await window.BenuteCart.add({ items: [{ id: Number(hidden.value), quantity: 1 }] }, button); }
        catch (error) { status.textContent = error.message; }
        finally { submitting = false; sync(); }
      });
      sync();
      if (dialog.open) title.tabIndex = -1;
    } catch (error) {
      if (current !== sequence || !dialog.open) return;
      dialog.classList.remove('is-loading'); dialog.setAttribute('aria-busy', 'false');
      status.textContent = error.name === 'AbortError' ? 'O carregamento demorou mais que o esperado.' : error.message;
      const link = el('a', 'bn-button', 'Abrir a peça →'); link.href = productURL; content.replaceChildren(link);
    }
  }
  document.addEventListener('click', event => { const button = event.target.closest('[data-bn-quick-url]'); if (button) { event.preventDefault(); show(button); } });
  const init = scope => scope.querySelectorAll('[data-bn-quick-url]').forEach(button => button.hidden = false);
  init(document); document.addEventListener('shopify:section:load', event => init(event.target));
})();
